import React, { useState } from 'react'
import ImageAndParagraph from '../../components/imageAndParagraph/imageAndParagraph'
import { useAppContext } from '../../App';
import { HStack, Text, useTheme, VStack } from '@chakra-ui/react';
import aboutUs1 from '../../innerAsstes/utils/aboutUs1.png';
import aboutUs2 from '../../innerAsstes/utils/aboutUs2.png';
import aboutUs3 from '../../innerAsstes/utils/aboutUs3.png';
import GridInspiredCard from '../../components/aboutUs/gridInspiredCard/gridInspiredCard';
import { CustomGrid } from '../../components/customGrid/customGrid';
import { ABOUT_US_DESCRIPTIONS, inspiredItems } from '../../utils/constants';
import resource1 from '../../innerAsstes/Logos certificaciones/oiep.jpg'
import resource2 from '../../innerAsstes/Logos certificaciones/cafop.jpg'
import resource3 from '../../innerAsstes/Logos certificaciones/universitam.jpg'
import resource4 from '../../innerAsstes/Logos certificaciones/utn.jpg'
import CertificactionCard from '../../components/aboutUs/certificationCard/certificarionCard';

export default function AboutUs() {
    const [highlight, setHighlight] = useState({
      mission: true,
      vision: false,
      values: false,
    });
    const [selectedDescription, setSelectedDescription] = useState(ABOUT_US_DESCRIPTIONS.mission);
    const {isMobile} = useAppContext();
    const theme = useTheme();
    const style = styles(theme, isMobile)
    function resetTextSelection(){
      return ['mission', 'vision', 'values' ].reduce((acc, val) =>{
        return ({
          ...acc,
          [val]: false,
        })
      },{});
    }
    const handleTextSelected = (tag) =>{
      setHighlight({...resetTextSelection(), [tag]:!highlight[tag] });
      setSelectedDescription(ABOUT_US_DESCRIPTIONS[tag]);
    }
    const certificationsArray = [
      {
        imgSrc: resource4,
        description: `El convenio entre Gestar y la Universidad Tecnológica
          Nacional - Facultad Regional Buenos Aires permite
          que muchos cursos cuenten con certiﬁcación oﬁcial.
          Ambas instituciones colaboran en la creación y
          ejecución de programas de cooperación, capacitación
          y asistencia técnica en áreas de interés común. Gestar
          se encarga de la promoción y ejecución de los
          programas, mientras que la Universidad Tecnológica
          Nacional supervisa aspectos académicos como
          contenidos, carga horaria y criterios de aprobación.`
      },
      {
        imgSrc: resource3,
        description: `En Gestar Educativa, nos enorgullecemos de nuestra
          alianza estratégica con UNIVERSITAM, una
          colaboración que refuerza nuestro compromiso con la
          excelencia educativa y la proyección internacional.
          Esta asociación nos permite ofrecer a nuestros
          estudiantes la oportunidad única de obtener
          certiﬁcaciones internacionales, añadiendo un valor
          signiﬁcativo a su formación profesional.`
      },
      {
        imgSrc: resource2,
        description: `El convenio entre Gestar y la Universidad Tecnológica
          Nacional - Facultad Regional Buenos Aires permite
          que muchos cursos cuenten con certiﬁcación oﬁcial.
          Ambas instituciones colaboran en la creación y
          ejecución de programas de cooperación, capacitación
          y asistencia técnica en áreas de interés común. Gestar
          se encarga de la promoción y ejecución de los
          programas, mientras que la Universidad Tecnológica
          Nacional supervisa aspectos académicos como
          contenidos, carga horaria y criterios de aprobación.`
      },
      {
        imgSrc: resource1,
        description: `En Gestar Educativa, nos enorgullecemos de nuestra
          alianza estratégica con UNIVERSITAM, una
          colaboración que refuerza nuestro compromiso con la
          excelencia educativa y la proyección internacional.
          Esta asociación nos permite ofrecer a nuestros
          estudiantes la oportunidad única de obtener
          certiﬁcaciones internacionales, añadiendo un valor
          signiﬁcativo a su formación profesional.`
      },
    ]
    
  return (
    <div>
      <ImageAndParagraph
        imgSrc={aboutUs1}
        fontFamily="quicksand-semibold"
        fontFamilyDescription="quicksand-semibold"
        titleFirst="SOMOS UN CENTRO DE FORMACIÓN,"
        titleSecond="CON MÁS DE 18 AÑOS DE TRAYECTORIA INNOVACIÓN Y TRANSFORMACIÓN EN ARGENTINA Y LATAM,"
        description="dedicada
                a brindar aprendizaje continuo,
                desarrollo de competencias en
                diversas disciplinas, herramientas
                y conocimientos."
        customStyles={style.section1}
      />
      <ImageAndParagraph
        imgSrc={aboutUs2}
        fontFamily="quicksand-semibold"
        fontFamilyDescription="quicksand-semibold"
        titleFirst="que permitan a las personas, de cualquier parte del país,"
        titleSecond="MEJORAR SU DESEMPEÑO, INSERTARSE EN EL MERCADO LABORAL, POTENCIAR SU EMPRENDIMIENTO Y/O CAPACITARSE PARA LA VIDA,"
        description="en un contexto altamente exigente, cambiante y global."
        buttonText="VER TODA NUESTRA OFERTA EDUCATIVA"
        buttonRedirectTo='/categorias-general/Cursos'
        customStyles={style.section2}
      />
      <ImageAndParagraph
        imgSrc={aboutUs3}
        fontFamily="quicksand-semibold"
        fontFamilyDescription="quicksand-semibold"
        titleFirst="Innovamos permanentemente"
        titleSecond="en cursos y formaciones.
            Hoy contamos con más de 130
            alternativas de formación, en
            diversas modalidades de estudio.
            Legitimadas por prestigiosas
            instituciones que brindan"
        description="CERTIFICACIÓN NACIONAL E INTERNACIONAL."
        buttonText="VER TODA NUESTRA OFERTA EDUCATIVA"
        buttonRedirectTo='/categorias-general/Cursos'
        customStyles={style.section3}
      />
      <CustomGrid
        items={certificationsArray} 
        iteratedComponent={CertificactionCard} 
        customStyles={{
          title:{
            alignSelf: 'flex-start',
            fontSize: "3rem",
            lineHeight: 1,
            color: theme.color.text.secondary,
            justifySelf: 'center'
          },
          container:{
            padding: 0,
            paddingTop: "4vh",
            paddingBottom: "4vh",
            backgroundColor: theme.background.seondary
          },
          grid:{
            width: '90%',
          }
        }}
      />
      <CustomGrid 
        title={'Nuestro proposito se inspira en:'}
        items={inspiredItems} 
        iteratedComponent={GridInspiredCard} 
        customStyles={{
          title:{
            alignSelf: 'flex-start',
            fontSize: isMobile? "1.4rem" : "3rem",
            textAlign: isMobile? "center" : 'left',
            paddingLeft: isMobile? '0.5rem' : "10vw",
            paddingTop: "4vh",
            paddingBottom: "4vh",
            lineHeight: 1,
            color: theme.color.text.secondary,
            justifySelf: 'center'
          },
          container: {
            padding: 0,
            paddingBottom: '4vh'
          },
          grid:{
            width: '90%',
          }
        }}
      />
      <VStack width={'80%'} justifySelf={'center'} paddingTop={'4vh'}>
        <HStack className='sansation-bold' justifyContent={'space-evenly'} width={isMobile? "100%" : '50%'}>
          <Text {...style.text(highlight.mission)} onClick={() => handleTextSelected('mission')}>MISIÓN</Text>
          <Text {...style.text(highlight.vision)} onClick={() => handleTextSelected('vision')}>VISIÓN</Text>
          <Text {...style.text(highlight.values)} onClick={() => handleTextSelected('values')}>VALORES</Text>
        </HStack>
        <Text
          fontSize={isMobile? "1rem" : '2rem'}
          className='quicksand-semibold'
          textAlign={'center'}
          color={theme.color.text.tertiary}
          pt={'4vh'}
          pb={'4vh'}
        >
          {selectedDescription}
        </Text>
      </VStack>
    </div>
  );
}
const styles = (theme, isMobile) => ({
  container: {},
  section1: {
    container: {
      alignContent: "center",
      flexDirection: isMobile? "column":"row-reverse",
      backgroundColor: theme.color.text.tertiary
    },
    title1: {
      fontSize: isMobile? "1.5rem" : "2rem",
      lineHeight: 1.2,
      color: theme.color.text.primary,
      textAlign: "left",
    },
    title2: {
      fontSize: isMobile? "1.5rem" : "2rem",
      lineHeight: 1.2,
      textAlign: "left",
      color: theme.color.text.primary,
      backgroundColor: theme.color.text.secondary,
    },
    textContainer: {
      alignContent: "center",
      width: isMobile? "100%" : "50%",
    },
    img: {
     alignSelf: "center",
    justifySelf: "center",
    width: isMobile ? "100%" : "50%",
    maxWidth: "500px", // Limita el ancho máximo (ajusta el valor según tu diseño)
    height: "auto",    // Mantiene la proporción original
    padding: 0,
    objectFit: "contain", // Asegura que la imagen no se deforme0
    },
    description: {
      textAlign: "left",
      color: theme.color.text.primary,
      fontSize: isMobile? "1.5rem" : "2rem",
      lineHeight: 1.2,
    },
  },
  section2: {
    container: {
      alignContent: "center",
      flexDirection: isMobile? "column" : "row",
      backgroundColor: theme.background.primary,
      height: '20%'
    },
    title1: {
      fontSize: isMobile? "1.5rem" : "2rem",
      textAlign: "left",
      lineHeight: 1.2,
      color: theme.color.text.primary,
    },
    title2: {
      fontSize: isMobile? "1.5rem" : "2rem",
      textAlign: "left",
      lineHeight: 1.2,
      color: theme.color.text.secondary,
    },
    textContainer: {
      alignContent: "center",
      width: isMobile? "100%" : "50%",
      padding:5
    },
    img: {
      alignSelf: "center",
    justifySelf: "center",
    width: isMobile ? "100%" : "50%",
    maxWidth: "500px", // Limita el ancho máximo (ajusta el valor según tu diseño)
    height: "auto",    // Mantiene la proporción original
    padding: 0,
    objectFit: "contain", // Asegura que la imagen no se deforme
    },
    description: {
      color: theme.color.text.primary,
      fontSize: isMobile? "1.5rem" : "2rem",
      textAlign: "left",
      lineHeight: 1.2,
    },
    buttonStyles: {
      container: {
        padding: 0,
        paddingRight: "1%",
        paddingLeft: "1%",
        height: "10%",
        width: isMobile? "50%" : "35%",
        marginTop: "2%",
        alignContent: "center",
        backgroundColor: theme.background.quaternary,
      },
      text: {
        padding: isMobile? "2%":"4%",
        fontSize: isMobile? "0.6rem":"0.8rem",
        width: isMobile? "70%":"90%",
        lineHeight: 1.2,
      },
      arrowSvg: {
        width: isMobile? "10%":"20%",
        height: "70%",
        circleColor: theme.background.primary,
      },
    },
  },
  section3: {
    container: {
      alignContent: "center",
      flexDirection: isMobile? "column" : "row-reverse",
    },
    title1: {
      fontSize: isMobile? "1.5rem" : "2rem",
      textAlign: "left",
      lineHeight: 1.2,
      color: theme.color.text.secondary,
    },
    title2: {
      fontSize: isMobile? "1.5rem" : "2rem",
      textAlign: "left",
      lineHeight: 1.2,
      color: theme.color.text.tertiary,
    },
    textContainer: {
      alignContent: "center",
      width: isMobile? "100%" : "50%",
      padding:5
    },
    img: {
      alignSelf: "center",
      justifySelf: "center",
      width: isMobile? "100%" : "50%",
      maxHeight: '60vh',
      padding: 0
    },
    description: {
      color: theme.color.text.secondary,
      fontSize: isMobile? "1.5rem" : "2rem",
      textAlign: "left",
      lineHeight: 1.2,
    },
    buttonStyles: {
      container: {
        padding: 0,
        paddingRight: "1%",
        paddingLeft: "1%",
        height: "10%",
        width: isMobile? "50%" : "35%",
        marginTop: "2%",
        alignContent: "center",
      },
      text: {
        padding: isMobile? "2%":"4%",
        fontSize: isMobile? "0.6rem":"0.8rem",
        width: isMobile? "70%":"90%",
        lineHeight: 1.2,
      },
      arrowSvg: {
        width: isMobile? "10%":"20%",
        height: "70%",
        circleColor: theme.background.primary,
      },
    },
  },
  text: (isHighlighted) => ({
    fontSize: isMobile? "1.5rem" : '2rem',
    color: theme.color.text.secondary,
    borderBottom: '1px solid',
    cursor: 'pointer',
    borderBottomColor: isHighlighted? theme.color.text.tertiary : '#fff',
    borderBottomWidth: isHighlighted? '2px' : 0,
  })
});
